import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const InactiveObservable = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="InactiveObservable"
    {...props}
  >
    <g clipPath="url(#clip0_1371_81126)">
      <path
        d="M15.0252 13.8488L18.5943 17.4171L17.4152 18.5963L13.8469 15.0271C12.5191 16.0915 10.8677 16.6704 9.16602 16.668C5.02602 16.668 1.66602 13.308 1.66602 9.16797C1.66602 5.02797 5.02602 1.66797 9.16602 1.66797C13.306 1.66797 16.666 5.02797 16.666 9.16797C16.6684 10.8696 16.0895 12.5211 15.0252 13.8488ZM10.1477 5.98214C9.43633 5.76314 8.67214 5.78852 7.97689 6.05424C7.28164 6.31996 6.69532 6.81072 6.31135 7.44834C5.92739 8.08596 5.76787 8.83374 5.85822 9.57253C5.94857 10.3113 6.28358 10.9986 6.80988 11.5249C7.33618 12.0512 8.02349 12.3863 8.76228 12.4766C9.50108 12.5669 10.2489 12.4074 10.8865 12.0235C11.5241 11.6395 12.0149 11.0532 12.2806 10.3579C12.5463 9.66267 12.5717 8.89849 12.3527 8.18714C12.2415 8.43272 12.0725 8.64768 11.86 8.81359C11.6476 8.9795 11.398 9.09139 11.1328 9.13968C10.8676 9.18798 10.5947 9.17122 10.3374 9.09086C10.0801 9.01049 9.8461 8.86891 9.65553 8.67827C9.46496 8.48762 9.32347 8.2536 9.2432 7.99626C9.16293 7.73893 9.14628 7.46597 9.19467 7.20078C9.24306 6.9356 9.35506 6.68611 9.52104 6.47371C9.68703 6.26132 9.90206 6.09235 10.1477 5.9813V5.98214Z"
        fill="white"
      />
      <rect width={10} height={10} transform="translate(4 4)" fill="white" />
      <path
        d="M9 8.11125L12.1113 5L13 5.88875L9.88875 9L13 12.1113L12.1113 13L9 9.88875L5.88875 13L5 12.1113L8.11125 9L5 5.88875L5.88875 5L9 8.11125Z"
        fill="#7F7F7F"
      />
    </g>
    <defs>
      <clipPath id="clip0_1371_81126">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(InactiveObservable);
